import { createApp } from 'vue';
import App from './App.vue';
import 'vuetify/styles';
import vuetify from '@/plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/colors.css';
import '@/assets/styles.css';
import axiosInstance from '@/plugins/axios';

// Cargar fuentes primero
loadFonts();

// Crear la aplicación Vue
const app = createApp(App);

// Configurar Axios como propiedad global
app.config.globalProperties.$axios = axiosInstance;

// Usar Vuetify
app.use(vuetify);

// Montar la aplicación
app.mount('#app');